export default __webpack_public_path__ + "static/FiraMono-Bold-c9b7e8a74f0c58865954275b21a399e7.woff2";